import React from "react";

export default function Loader({ text = "Loading..." }) {
  return (
    <div className="np-loader" role="status" aria-live="polite">
      <span className="np-loader__spinner" aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
}
